import React from "react"
import btnLink from "./../assets/icons/play.png"
import RatingOrange from "./../assets/icons/star_org.png"
import RatingGray from "./../assets/icons/star_gray.png"
import back from "./../assets/icons/back.png"
import "./BannerGame.scss"
import {Link} from "react-router-dom"
import defaultImage from "../assets/images/default-image.png"

function BannerGame(props) {
    console.log(">>>props::", props)
    const {game} = props
    const rating = Array(5)
        .fill(0)
        .map((item, i) => (i <= 3
            ? <img key={i} src={RatingOrange} alt="stars" className="mr-1"/>
            : <img key={i} src={RatingGray} alt="stars" className="mr-1"/>))
    function addDefaultSrc(e) {
        e.target.src = defaultImage
    }
    return (
        <div className="columns is-gapless pagebanner is-mobile is-multiline">
            <div className="column p-r is-full">
                <Link to="/" className="navitem">
                    <img src={back} alt="back to home"/>
                </Link>
                <figure className="image">
                    <img src={game.bannerImage} onError={addDefaultSrc} alt="demo"/>
                </figure>
                <div className="fixb">
                    <div className="media">
                        <div className="media-left" style={{maxWidth: '90%'}}>
                            <h5 className="title is-capitalized is-5 pb-2 has-text-white mb-4">{game.gameName}</h5>
                            <h6 className="subtitle is-7 has-text-white mb-0">{game.gamePlayed}</h6>
                            <div className="rating has-text-white">
                                {rating}
                                <small className="has-text-weight-light">
                                    4.5 (259 reviews)</small>
                            </div>
                        </div>
                        <div className="media-right">
                            <a href={game.url}>
                                <img src={btnLink} alt="game page link"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="column is-full">
                <div className="p-3">
                    <p className="subtitle is-6 has-text-white rt">{game.gameDescription}</p>
                </div>
            </div>
        </div>
    )
}

export default BannerGame